export enum HarvestingTime {
    MORNING = 'Morning',
    EVENING = 'Evening'
}